export default __webpack_public_path__ + "static/2-analyze-ebc6d57201fa79546cc812d20ce1fd23.png";